import React from 'react';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../../Selects/SelectComponent';

function Atributos({atributo, aluguer}) {
    const {t} = useTranslation();
    return (
        <tr className="bg-gray-100 border-b  border-white dark:bg-gray-600 dark:border-gray-700 ">
            <td className="text-left py-2">
                <button
                    title={t('atributos')}
                    type="button"
                    className="relative ml-6 inline-flex items-center font-bold p-1  text-xs  text-center cursor-pointer rounded-[5px] bg-blue-200 dark:bg-blue-400  text-blue-600 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 ">
                    AT
                </button>
            </td>
            <td className="px-6 "></td>
            <td className="px-6 "></td>
            <td className="px-6 ">{atributo?.label}</td>
            <td className="px-6 "></td>
            <td className="px-6 "></td>
            <td className="px-6 "></td>
            {!aluguer && <td className="px-6 py-1"></td>}
            {/* <td className="px-6 py-1"></td> */}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}

            <td className="px-6 "></td>
        </tr>
    );
}

export default Atributos;
